import { combineReducers } from 'redux';

import storage from 'redux-persist/lib/storage' // defaults to localStorage for web and AsyncStorage for react-native
import { persistReducer } from 'redux-persist'


import TextReducer from './TextReducer';
import AuthReducer from './AuthReducer';
import UserReducer from './UserReducer';


const persistConfig = {
  key: 'root',
  storage
}


const AuthReducerPersisted = persistReducer(persistConfig, AuthReducer)


export default combineReducers({
  // the keys here are going to be the property of state that we are producing.
  text_reducer: TextReducer,
  auth_reducer: AuthReducerPersisted,
  user_reducer: UserReducer
});



// WEBPACK FOOTER //
// ./src/Reducers/index.js